import React from "react";
import { Button } from "@/components/ui/button";

export default function SectionHeader({ title, description, actionLabel, actionIcon, onAction }) {
  return (
    <div className="flex items-start justify-between mb-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">
          / {title.toLowerCase().replace(/\s+/g, '-')}
        </div>
        <h2 className="text-lg font-medium tracking-tight mt-0.5">{title}</h2>
        <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
      </div>
      {actionLabel && (
        <Button size="sm" onClick={onAction} className="rounded-sm h-8 text-xs shrink-0">
          {actionIcon && React.createElement(actionIcon, { className: "w-3.5 h-3.5 mr-1.5" })}
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
